import { useQuery } from "@tanstack/react-query";
import { fetchContact } from "../services/contactsServices";

const useContact = (contactID) => {
  return useQuery({
    queryKey: ["contact", contactID],
    queryFn: () => fetchContact(contactID),
    enabled: !!contactID,
  });
};

export default useContact;
